/**
 * Dashboard Insights Data
 * 
 * Static data for dashboard insights carousel
 */

export const DASHBOARD_INSIGHTS = [
  {
    id: 1,
    tag: 'finance',
    title: 'New Tax Filing Deadline Extended',
    description: 'The IRS has extended the tax filing deadline for Q4 2023. Review your documents to stay compliant.',
  },
  {
    id: 2,
    tag: 'ai',
    title: 'AI Contract Analysis Now Live',
    description: 'Our new AI-powered contract analysis feature can identify risks and suggest improvements in seconds.',
  },
  {
    id: 3,
    tag: 'tech',
    title: 'Platform Update: Enhanced Security',
    description: 'We\'ve rolled out enhanced security features including two-factor authentication and encrypted storage.',
  },
  {
    id: 4,
    tag: 'privacy',
    title: 'GDPR Compliance Updates',
    description: 'New privacy regulations are in effect. Ensure your contracts and data handling are compliant.',
  },
];

/**
 * Tag style mapping for insights
 */
export const TAG_STYLES = {
  finance: 'bg-tag-finance-bg text-tag-finance-text',
  ai: 'bg-tag-ai-bg text-tag-ai-text',
  tech: 'bg-tag-tech-bg text-tag-tech-text',
  privacy: 'bg-tag-privacy-bg text-tag-privacy-text',
};

